module.exports = __webpack_public_path__ + "alumni-80a5a278.webp";